export const VIEWPORT_OFFSET = '48px'
export const VISIBLE_TOASTS_AMOUNT = 3
export const TOAST_LIFETIME = 2200
export const TOAST_WIDTH = 432
export const GAP = 8
export const TIME_BEFORE_UNMOUNT = 200
